import React from 'react';
import { Box, Typography, Link as MuiLink } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import FacebookIcon from '@mui/icons-material/Facebook';
import GoogleIcon from '@mui/icons-material/Google';

const BRAND_BLUE = '#14a9e8';

const Footer = () => {
  return (
    <footer
      aria-label="Site footer"
      style={{
        background: BRAND_BLUE,                // same color as the top banner
        padding: '12px 0',
        textAlign: 'center',
        width: '100%',
        boxShadow: '0 -4px 6px rgba(0, 0, 0, 0.08)',
        position: 'relative',
        color: '#fff',
      }}
    >
      <Box
        component="address"
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'center',
          alignItems: 'center',
          gap: { xs: 1, sm: 3 },
          fontStyle: 'normal',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <PhoneIcon sx={{ fontSize: 18 }} aria-hidden />
          <MuiLink
            href="tel:+15416061706"
            underline="none"
            sx={{
              color: '#ffffff',
              '&:hover': { textDecoration: 'underline' },
              fontSize: { xs: '0.95rem', sm: '1rem' },
            }}
            aria-label="Call Lowen Behold Cleaning at (541) 606-1706"
          >
            (541) 606-1706
          </MuiLink>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <EmailIcon sx={{ fontSize: 18 }} aria-hidden />
          <MuiLink
            href="mailto:lowenbeholdcleaning@gmail.com"
            underline="none"
            sx={{
              color: '#ffffff',                 // match banner (white on blue)
              '&:hover': { textDecoration: 'underline' },
              '&:focus-visible': {
                outline: '2px solid #ffffff',
                outlineOffset: '2px',
                borderRadius: '4px',
              },
              fontSize: { xs: '0.95rem', sm: '1rem' },
            }}
            aria-label="Email Lowen Behold Cleaning at lowenbeholdcleaning@gmail.com"
          >
            lowenbeholdcleaning@gmail.com
          </MuiLink>
        </Box>

        {/*<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <FacebookIcon sx={{ fontSize: 18 }} aria-hidden />
           <MuiLink
            href="https://www.facebook.com/profile.php?id=61552687223734"
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            sx={{
              color: '#ffffff',
              display: 'inline-flex',
              alignItems: 'center',
              '&:hover': { textDecoration: 'underline' },
              '&:focus-visible': {
                outline: '2px solid #ffffff',
                outlineOffset: '2px',
                borderRadius: '4px',
              },
              fontSize: { xs: '0.95rem', sm: '1rem' },
            }}
            aria-label="Open Lowen Behold Cleaning Facebook page in a new tab"
          >
            Facebook
          </MuiLink>
        </Box> */}

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <GoogleIcon sx={{ fontSize: 18 }} aria-hidden />
          <MuiLink
            href={process.env.REACT_APP_GOOGLE_REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            sx={{
              color: '#ffffff',
              display: 'inline-flex',
              alignItems: 'center',
              '&:hover': { textDecoration: 'underline' },
              '&:focus-visible': {
                outline: '2px solid #ffffff',
                outlineOffset: '2px',
                borderRadius: '4px',
              },
              fontSize: { xs: '0.95rem', sm: '1rem' },
            }}
            aria-label="Review Lowen Behold Cleaning on Google"
          >
            Google Reviews
          </MuiLink>
        </Box>
      </Box>

      <Typography
        variant="body2"
        sx={{
          color: 'rgba(255,255,255,0.85)',
          fontSize: { xs: '0.7rem', sm: '0.75rem' },
          mt: { xs: 1, sm: 1.5 },
        }}
      >
        © Lowen Behold Cleaning LLC. {new Date().getFullYear()}
      </Typography>
    </footer>
  );
};

export default Footer;